import _extends from "@babel/runtime/helpers/esm/extends";
import { GridPushPinRightIcon, GridPushPinLeftIcon } from './icons';
const iconSlots = {
  ColumnMenuPinRightIcon: GridPushPinRightIcon,
  ColumnMenuPinLeftIcon: GridPushPinLeftIcon
};
const materialSlots = _extends({}, iconSlots);
export default materialSlots;